import React, {useEffect, useRef, useState} from 'react';
import Layout from '../../../components/layout/Layout';
import {sendData} from '../../../store/actions';
import {useDispatch} from 'react-redux';
import {useHistory, useLocation, useParams} from "react-router-dom";
import {
    checkLowercase,
    checkMinLength,
    checkNumeric,
    checkSpecialCharacter,
    checkUppercase,
    handleError, isMobileDevice
} from '../../../common/functions';
import {createCookie, eraseCookie, getCookie, checkCookie} from 'ubs-framework/v2/common/cookie';
import useSocket from "../../common/useSocket";
import AppHeader from "../../common/components/app-header";
import UInput from "../../../common/component/UInput";
import UPopup from "../../../common/component/UPopup";
import * as Icon from 'ubs-icons';
import Validator from "simple-react-validator";
import {useForceUpdate} from "../../common/useForceUpdate";
import Commonrightcircle from "../../../common/component/RightCircle/commonrightcircle";
import CommonInvite from "../../../common/component/CommonInvite/CommonInvite";
import {COLOR, REGEX} from "../../../common/constant";

//emailNotMatching accept register  loginAndAccept invitationAlreadyAccepted invitationCodeExpired accountNotVerified  wrong

function RegisterInvite() {
    const dispatch = useDispatch();
    const history = useHistory();
    let location = useLocation();
    const [errorMsg, setErrorMsg] = useState("");
    const [flag, setFlag] = useState(''); // accept, register
    const [invitedData, setInvitedData] = useState({}); // invited member data
    const [passwordEye, setPasswordEye] = useState(false)
    const [registerDetail, setRegisterDetail] = useState({
        firstName: "",
        lastName: "",
        email: "",
        password: ""
    })
    const [disableBtn, setDisableBtn] = useState(false)

    const {code} = useParams();
    const forceUpdate = useForceUpdate()
    const validator = useRef(new Validator({
        element: (message, className) => <div className="u_error_message">{message}</div>,
        autoForceUpdate: {forceUpdate},
        validators: {
            uppercase: {  // name the rule
                message: 'Please use uppercase.',
                rule: (val, params, validator) => {
                    return validator.helpers.testRegex(val, REGEX.upperCase) && params.indexOf(val) === -1
                },
            },
            lowercase: {  // name the rule
                message: 'Please use lowercase.',
                rule: (val, params, validator) => {
                    return validator.helpers.testRegex(val, REGEX.lowerCase) && params.indexOf(val) === -1
                },
            },
            specialcase: {  // name the rule
                message: 'Please use one special character.',
                rule: (val, params, validator) => {
                    return validator.helpers.testRegex(val, REGEX.specialChar) && params.indexOf(val) === -1
                },
            },
            number: {  // name the rule
                message: 'Please use one number.',
                rule: (val, params, validator) => {
                    return validator.helpers.testRegex(val, REGEX.number) && params.indexOf(val) === -1
                },
            },
        }
    }));


    const {on, off, refresh} = useSocket(res => {
        setDisableBtn(false)
        if (!res.error) {
            switch (res.event) {
                case 'authenticate':
                    let path = window.location.pathname.split('/')[1]
                    if (path && path === 'invite') {
                        const data = {inviteCode: location.pathname.split('/')[2], token: getCookie("ubs_token")}
                        sendData(dispatch, 'verifyInvitationCode', data);
                    }
                    break;
                case 'verifyInvitationCode':
                    setInvitedData(res.data)
                    if (res.data.invitationCodeExpired) setFlag("invitationCodeExpired")
                    else if (res.data.invitationAlreadyAccepted) setFlag("invitationAlreadyAccepted")
                    else if (res.data.accountNotVerified) setFlag("accountNotVerified")
                    else if (res.data.emailNotMatching) setFlag("emailNotMatching")
                    else if (res.data.userAvailability) {
                        if (!checkCookie('ubs_token')) {
                            setFlag("loginAndAccept")
                            createCookie('previousURL', window.location.href);
                        } else setFlag("accept")
                    } else if (typeof res.data.userAvailability === 'boolean' && !res.data.userAvailability) setFlag("register")
                    else {
                        setFlag("wrong")
                    }
                    dispatch({type: 'SET_EMAIL', payload: res.data.email});
                    break;
                case 'registerAsMember':
                    history.push('/verify-email')
                    break;
                case 'acceptInvitation':
                    history.push("/workspace")
                    break;
                default:
                    return true;
            }
        } else {
            handleError(setErrorMsg, res.data.error)
        }
    })
    useEffect(() => {
        if (checkCookie('ubs_token')) sendData(dispatch, 'authenticate', {token: getCookie("ubs_token")})
        else {
            const data = {inviteCode: location.pathname.split('/')[2]}
            if (checkCookie('ubs_token')) data.token = getCookie("ubs_token")
            sendData(dispatch, 'verifyInvitationCode', data);
        }
        on();
        return () => off();
    }, [])

    useEffect(() => {
        if (invitedData.email) {
            setTimeout(() => {
                setValue('email', invitedData.email)
            }, 1000);
        }
        return () => {
        }
    }, [invitedData])

    const onSubmit = () => {
        if (validator?.current?.allValid()) {
            let data = {...registerDetail, inviteCode: code}
            setDisableBtn(true)
            sendData(dispatch, 'registerAsMember', data);
        } else {
            validator?.current?.showMessages()
        }

    }
    const acceptInvitation = () => {
        const data = {inviteCode: location.pathname.split('/')[2]}
        sendData(dispatch, 'acceptInvitation', data);
    }
    const logout = () => {
        if (localStorage.getItem('notification_token')) sendData('logout', {device_token: localStorage.getItem('notification_token')})
        dispatch({type: 'LOGOUT'});
        localStorage.clear()
        eraseCookie('ubs_token')
        eraseCookie('ubsTabId')
        history.push('/login')
        window.location.reload(true)
    }

    const inpEvent = (e) => {
        let {name, value} = e.target
        value = value.replace(/^\s+/g, '').trim();
        setRegisterDetail((val) => {
            return {...val, [name]: value}
        })
    }

    const onKeyUp = e => {
        if (e.key === "Enter") {
            onSubmit()
        }
    }

    return (<React.Fragment>
            <Layout module={(flag !== 'loginAndAccept' && flag !== 'invitationAlreadyAccepted') && 'register'}>
                {flag === "register" && <div>
                    <div className="u_account-form">
                        <Commonrightcircle/>
                        <AppHeader header="Register to Superworks"
                                   title="Thank you for get back to Superworks, Let’s access our the best recommendation for you. "/>
                        <UInput
                            hasError={validator?.current?.message("firstName", registerDetail?.firstName, "required")}
                            className="u_mb-20" label="First Name" asterisk>
                            <input onKeyUp={onKeyUp} name="firstName" placeholder=" " name="firstName"
                                   value={registerDetail?.firstName}
                                   onChange={inpEvent}
                                   autoComplete="off"/>
                        </UInput>
                        <UInput hasError={validator?.current?.message("lastName", registerDetail?.lastName, "required")}
                                className="u_mb-20" label="Last Name" asterisk>
                            <input onKeyUp={onKeyUp} name="lastName" placeholder=" " name="lastName"
                                   value={registerDetail?.lastName}
                                   onChange={inpEvent}
                                   autoComplete="off"/>
                        </UInput>
                        <UInput hasError={validator?.current?.message("email", registerDetail?.email, "required|email")}
                                className="u_mb-20" label="Email Address" asterisk>
                            <input onKeyUp={onKeyUp} name="email" placeholder=" " name="email"
                                   value={registerDetail?.email}
                                   onChange={inpEvent}/>
                        </UInput>

                        <UInput
                            hasError={validator?.current?.message("password", registerDetail?.password, "required|min:8|uppercase|lowercase|specialcase|number")}
                            className="u_mb-20" label="Password" password asterisk>
                            <input onKeyUp={onKeyUp} name="password" placeholder=" " value={registerDetail?.password}
                                   onChange={inpEvent}
                                   type={`${!passwordEye ? "password" : "text"}`}
                                   autoComplete="off"/>
                            <div className="u_input-note u_ib">
                                <UPopup params={{className: "u_tooltip u_tooltip-full", disabled: isMobileDevice()}}
                                        desc={<span>{!passwordEye ? "Show Password" : "Hide Password"} </span>}>
                                    <span className="u_rollover u_cp u_flex"
                                          onClick={() => setPasswordEye(!passwordEye)}>{!passwordEye ?
                                        <Icon.HideEye size={18} fill={COLOR.u_icon_bg}/> :
                                        <Icon.Eye size={18} fill={COLOR.u_icon_bg}/>}</span>
                                </UPopup>
                            </div>
                        </UInput>

                        <div className="u_reset-content u_mb-10">
                            <ul className="u_flex u_flex-wrap">
                                <li style={{color: `${checkMinLength(registerDetail.password, 8) ? '#60B158' : '#8F95A6'}`}}>
                                    <Icon.DoubleTick size={18} className="u_mr-10 u_ib u_align-middle"
                                                    fill={`${checkMinLength(registerDetail?.password, 8) ? '#60B158' : '#8F95A6'} `}/>Minimum
                                    8 Characters
                                </li>
                                <li style={{color: `${checkUppercase(registerDetail.password) ? '#60B158' : '#8F95A6'} `}}>
                                    <Icon.DoubleTick size={18} className="u_mr-10 u_ib u_align-middle"
                                                    fill={`${checkUppercase(registerDetail?.password) ? '#60B158' : '#8F95A6'}`}/>Uppercase
                                </li>
                                <li style={{color: `${checkLowercase(registerDetail.password) ? '#60B158' : '#8F95A6'} `}}>
                                    <Icon.DoubleTick size={18} className="u_mr-10 u_ib u_align-middle"
                                                    fill={`${checkLowercase(registerDetail?.password) ? '#60B158' : '#8F95A6'}`}/>Lowercase
                                </li>
                                <li style={{color: `${checkNumeric(registerDetail.password) ? '#60B158' : '#8F95A6'} `}}>
                                    <Icon.DoubleTick size={18} className="u_mr-10 u_ib u_align-middle"
                                                    fill={`${checkNumeric(registerDetail?.password) ? '#60B158' : '#8F95A6'}`}/>1
                                    Numeric Number
                                </li>
                                <li style={{color: `${checkSpecialCharacter(registerDetail.password) ? '#60B158' : '#8F95A6'} `}}>
                                    <Icon.DoubleTick size={18} className="u_mr-10 u_ib u_align-middle"
                                                    fill={`${checkSpecialCharacter(registerDetail?.password) ? '#60B158' : '#8F95A6'}`}/>1
                                    Special Character
                                </li>
                            </ul>
                        </div>

                    </div>
                    {errorMsg.length !== 0 && (
                        <p className="u_error-message u_mb-15">{errorMsg}</p>
                    )}
                    <div className="u_block u_relative">
                        <button disabled={disableBtn} type="button" onClick={onSubmit}
                                className={`u_account-btn u_w-full u_cp`}>Next
                        </button>
                        {disableBtn && <div className="u_btn-loader"><Icon.Preloader size={70} /></div>}
                    </div>
                </div>}
                {flag === 'invitationCodeExpired' && <div className="u_account-form">
                    <Commonrightcircle/>
                    <img src="../images/images/invitationExpired.png" className="u_m-auto"/>
                    <CommonInvite heading="Invitation Expired" title="This invitation link is no longer valid. please get in touch with
                            the person who shared the invite link with you to ask for an invitation"/>
                    {!checkCookie("ubs_token") &&
                    <button className="u_account-btn u_w-full u_cp"
                            onClick={() => history.push("/login")}>Sign In</button>}
                    {checkCookie("ubs_token") &&
                    <button className="u_account-btn u_w-full u_cp"
                            onClick={() => history.push("/workspace")}>Continue</button>}

                </div>}
                {flag === "accountNotVerified" && <div className="u_account-form">
                    <Commonrightcircle/>
                    <img src="../images/images/varification.png" className="u_m-auto"/>
                    <CommonInvite heading="Verification" title="You need to verify your account"/>
                    <button className="u_account-btn u_w-full u_cp"
                            onClick={logout}>Logout
                    </button>
                </div>}
                {flag === "invitationAlreadyAccepted" && <div className="u_account-form">
                    <Commonrightcircle/>
                    <div className="u_sendmail-section u_t-center u_mt-50">
                            <span className="u_sendmail-icon u_ib u_relative">
                                <img className="u_tnkuRound" src="../images/images/u-tnkuRound.png" alt="Round"/>
                                <img className="u_emailIcon" src="../images/images/u-emailIcon.png" alt="emailIcon"/>
                                <img className="u_tnkuLine" src="../images/images/u-tnkuLine.png" alt="Line"/>
                            </span>
                    </div>
                    <CommonInvite heading="Accepted"
                                  title="This email address is already registered. Please verify your email address by login"/>
                    {checkCookie("ubs_token") && <button className="u_account-btn u_w-full u_cp"
                                                         onClick={() => history.push("/workspace")}>Continue</button>}
                    {!checkCookie("ubs_token") && <button className="u_account-btn u_w-full u_cp"
                                                          onClick={() => history.push("/login")}>Sign In</button>}

                </div>}
                {flag === "loginAndAccept" && <div className="u_account-form">
                    <Commonrightcircle/>
                    <img src="../images/images/accountFound.png" className="u_m-auto"/>
                    <CommonInvite heading="Account Found" title="Please sign in to accept the invite"/>
                    <button onClick={() => history.push('/login')} className="u_account-btn u_w-full u_cp">Sign In
                    </button>
                </div>}
                {flag === "accept" && <div className="u_account-form">
                    <Commonrightcircle/>
                    <div className="u_sendmail-section u_t-center u_mt-50">
                            <span className="u_sendmail-icon u_ib u_relative">
                                <img className="u_tnkuRound" src="../images/images/u-tnkuRound.png" alt="Round"/>
                                <img className="u_emailIcon" src="../images/images/roundLogo.png" alt="emailIcon"/>
                                <img className="u_tnkuLine" src="../images/images/u-tnkuLine.png" alt="Line"/>
                            </span>
                    </div>
                    <CommonInvite heading="Invitation" title="You have been invited to join “Superworks”."
                                  error={errorMsg}/>
                    <button onClick={acceptInvitation} className="u_account-btn u_w-full u_cp">
                        Login
                    </button>
                </div>}
                {flag === "wrong" && <div className="u_account-form">
                    <Commonrightcircle/>
                    <img src="../images/images/404.png" className="u_m-auto"/>
                    <CommonInvite heading="Oops.." title="Something went wrong!. Please try again after some time"/>
                    <button onClick={() => history.push('/login')} className="u_account-btn u_w-full u_cp">
                        Login
                    </button>
                </div>}
                {flag === "emailNotMatching" && <div className="u_account-form">
                    <Commonrightcircle/>
                    <img src="../images/images/emailNotMatch.png" className="u_m-auto"/>
                    <CommonInvite heading="Email Not Match"
                                  title="You have logged in with different email. please logout that account and try again."/>
                    <button className="u_account-btn u_w-full u_cp"
                            onClick={logout}>Logout
                    </button>
                </div>}
            </Layout>
        </React.Fragment>
    );
}


export default RegisterInvite;
